import { PayloadAction } from '@reduxjs/toolkit';

import { LivePreviewScenesPayload, LivePreviewState } from '../types';

const setLivePreviewScenesReducer = (state: LivePreviewState, action: PayloadAction<LivePreviewScenesPayload>) => {
  const { productUid, areaTokens, scenes } = action.payload;
  state.productUid = productUid;
  state.areaTokens = areaTokens ?? [];
  state.scenes = scenes ?? [];
  const stillExists = state.scenes.some((scene) => scene.scene_name === state.selectedSceneName);
  state.selectedSceneName = stillExists ? state.selectedSceneName : state.scenes[0]?.scene_name;
};

export default setLivePreviewScenesReducer;
